module.exports = __webpack_public_path__ + "static/media/notifications.634cc222.svg";